import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const assistantChatArchiveMutationAtom = createMutationAtomFactory(
  'assistant.chatArchive',
  (params: { id: string }) => ({
    assistantArchiveChat: {
      __args: {
        id: params.id,
      },
      id: true,
      status: true,
    },
  }),
);
